import React from 'react';

const ResponsibilityItem = ({ children }) => {
  return (
    <div className="flex items-start">
      <span className="text-green-500 mr-3 text-xl">✓</span>
      <p className="text-gray-700">{children}</p>
    </div>
  );
};

export default ResponsibilityItem;
